import styled from "styled-components";

export const AdminLoginBox = styled.form`
  display: flex;
  width: 380px;
  max-height: 490px;
  padding: 60px;
  background: ${(props) => props.theme.colors.white};
  border-radius: 10px;
  box-shadow: ${(props) => props.theme.shadow.light};
  flex-direction: column;
  gap: 40px;

  //모바일 화면 설정
  @media screen and (max-width: 768px) {
    padding: 0;
    background: none;
  }
`;

export const LoginTit = styled.div`
  color: white;
  font-size: 3rem;
  font-weight: 600;
  color: ${(props) => props.theme.colors.adminMainTxt};
`;

export const LoginInputBox = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 10px;
`;
